const HalfStadiumDecorator = ({ ...rest }) => (
  <svg width="31" height="31" viewBox="0 0 31 31" {...rest}>
    <path
      d="M0.648926 15.9342C0.648926 7.61348 7.39424 0.868164 15.715 0.868164H30.2529V31.0003H15.715C7.39424 31.0003 0.648926 24.255 0.648926 15.9342Z"
      fill="currentColor"
    />
  </svg>
);

export { HalfStadiumDecorator };
